import { render } from "./EbayRrShippingDocs.vue?vue&type=template&id=fba68422&scoped=true"
import script from "./EbayRrShippingDocs.vue?vue&type=script&lang=js"
export * from "./EbayRrShippingDocs.vue?vue&type=script&lang=js"

import "./EbayRrShippingDocs.vue?vue&type=style&index=0&id=fba68422&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fba68422"]])

export default __exports__